import React, { useEffect, useState } from "react"
import { Button, makeStyles } from "@material-ui/core"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { useHistory } from "react-router-dom"
import { deleteCaseRequest } from "../../actions/bifrostActions"
import { ROUTES } from "../../utils"

const useStyles = makeStyles((theme) => ({
	deleteCasePopWrapper: {
		textAlign: "center",
		marginBottom: "13px"
	},
	description:{
		fontSize: "16px",
		marginBottom: "29px"
	},
    primaryBtn: {
		width: "165px",
		height: "40px",
		textTransform: "initial",
		fontSize: "14px",
		marginRight: "16px"
	},
	footerWrapper: {
		textAlign: "center"
	}
}))

const DeleteCase = ({ data, callback }) => {
    const classes = useStyles()
	const history = useHistory()
    const dispatch = useDispatch()
    const [t] = useTranslation("global")

	const { alert } = useSelector((state) => state.alert)
	const isDeleteCaseLoading = useSelector((state) => state.bifrostCase.isDeleteCaseLoading)
	const isCaseDeleted = useSelector((state) => state.bifrostCase.isCaseDeleted)
	const deleteCaseDetailsError = useSelector((state) => state.bifrostCase.deleteCaseDetailsError)

	useEffect(()=>{
		if(isCaseDeleted){
			callback(false)
			history.push(ROUTES.BIFROST)
		}
	},[isCaseDeleted])
	
	useEffect(()=>{
		if(deleteCaseDetailsError != undefined && deleteCaseDetailsError != ''){
			callback(false)
		}
	},[deleteCaseDetailsError])

	const handleDeleteCase = () => {
        dispatch(deleteCaseRequest(data))
    }

    return (
        <>
            <section className={classes.deleteCasePopWrapper}>   
				{	alert?.msg && <div className={alert?.class}>
						{alert?.msg}
					</div>
				}
                <p className={classes.description}>{`${t("bifrost.deleteCase.descriptionOne")} "${data.name}" ${t("bifrost.deleteCase.descriptionTwo")}`}</p>
				<nav className={classes.footerWrapper}>
                    <Button
						variant="outlined"
						color="primary"
						className={classes.primaryBtn}
						onClick={(e) => {
							callback(false)
						}}
					>
						{t("bifrost.buttonTexts.cancel")}
					</Button>
					<Button
						variant="contained"
						color="primary"
						className={classes.primaryBtn}
						onClick={(e) => {
							handleDeleteCase(e)
						}}
						disabled={isDeleteCaseLoading}
					>
						{t("bifrost.buttonTexts.delete")}
					</Button>
                </nav>
            </section>
        </>
    )
}

export default DeleteCase
